// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-SkeletonValue_cls1__MC0DB","cls2":"VeloLabelledItem-SkeletonValue_cls2__ikjdC VeloLabelledItem-SkeletonValue_cls1__MC0DB"};